/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2019 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import * as R from 'ramda';
import { createSelector } from 'reselect';
import { getRouteParam } from '@nebula/rover';
import { selectSessionsList } from '@nebula/dorado-redux-storage';
import getEnv from '../../casing/env';

export const selectSessionRouteParam = state => getRouteParam('session', state);

export const selectActiveSessionLink = (form, state) => {
  const session = selectActiveSession(state);
  const link = R.propOr('', 'link', form.export(state));

  try {
    const url = new URL(link);
    url.searchParams.append('adb_validation_sessionid', session.uuid);

    const env = getEnv();
    if (env !== 'prod' && env !== 'local') {
      url.searchParams.append('env', env);
    }

    return url.href;
  } catch (e) {
    return link;
  }
};

export const selectActiveSession = createSelector(
  selectSessionsList,
  selectSessionRouteParam,
  (list, id) => R.values(list).find(item => item.uuid === id) || {}
);

export const selectActiveSessionName = createSelector(
  selectActiveSession,
  R.propOr('', 'name')
);

export const selectActiveSessionToken = createSelector(
  selectActiveSession,
  R.propOr('', 'token')
);
